module.exports = __webpack_public_path__ + "static/media/MHRP09N0004.1fa79394.svg";